// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/assets/iconfont/rticonfont.css
// module id = 1575
// module chunks = 228